import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useJWTAuth } from './JWTAuthContext';
import { mustChangePassword } from '../utils/schoolSession';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated, isMobileVerified, isLoading } = useJWTAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // A school's temporary password must be replaced first; the API refuses
  // every other call (428) until it is.
  if (mustChangePassword() && location.pathname !== '/set-password') {
    return <Navigate to="/set-password" replace />;
  }

  // Redirect to mobile verification if not verified (except if already on verify-mobile page)
  if (!isMobileVerified && location.pathname !== '/verify-mobile') {
    console.log('PrivateRoute: User not mobile verified, redirecting to /verify-mobile');
    return <Navigate to="/verify-mobile" replace />;
  }

  // Render the protected component if authenticated and mobile verified
  return <>{children}</>;
};

export default PrivateRoute;
